import request from "@/utils/request";

export function getHalls(museumId) {
  // console.log(museumId)
  let params = {
    museumId: museumId,
  };
  return request({
    url: `/api/ExcursionHalls/GetHalls/${museumId}`,
    method: `get`,
    params,
  });
}

export function postHalls(data, params) {
  return request({
    url: `/api/ExcursionHalls/CreateHall/${params.museumId}`,
    method: `post`,
    params,
    data,
  });
}

export function getHallById(id) {
  let params = {
    id: id,
  };
  return request({
    url: `/api/ExcursionHalls/GetHall/${id}`,
    method: `get`,
    params,
  });
}

export function putHall(id, payload) {
  const params = {
    id: id,
  };
  const data = {
    order: payload.order,
    title: payload.title,
    floor: payload.floor || null,
  };
  return request({
    url: `/api/ExcursionHalls/UpdateHall/${id}`,
    method: `put`,
    data,
    params,
  });
}

export function deleteHall(id, params) {
  return request({
    url: `/api/ExcursionHalls/DeleteHall/${id}`,
    method: "delete",
    params,
  });
}
